import { global } from 'stylist'

global()



// WEBPACK FOOTER //
// ./src/styles/global.js